import React, { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Aggiorna lo stato così il prossimo render mostrerà l'UI di fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Puoi anche loggare l'errore in un servizio di reporting
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    console.error("Errore catturato dal boundary:", error, errorInfo);
  }
  
  // Resetta lo stato e tenta di recuperare
  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  }

  render() {
    if (this.state.hasError) {
      // Puoi renderizzare qualsiasi UI di fallback
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-stone-900 text-amber-100 p-4">
          <div className="bg-stone-800 p-6 rounded-lg max-w-md w-full shadow-lg text-center">
            <div className="flex justify-center mb-4 text-amber-500">
              <AlertTriangle size={64} />
            </div>
            
            <h2 className="text-xl font-bold mb-4 text-amber-300">
              Ops! Qualcosa è andato storto
            </h2>
            
            <p className="mb-6 text-sm">
              Si è verificato un errore imprevisto nell'applicazione. 
              Ci scusiamo per l'inconveniente.
            </p>
            
            <div className="mb-6 p-3 bg-stone-900 rounded text-left text-xs overflow-auto max-h-40">
              <p className="text-red-400">
                {this.state.error && this.state.error.toString()}
              </p>
            </div>
            
            <div className="flex flex-col gap-3">
              <button 
                onClick={this.handleReset}
                className="w-full py-3 bg-green-700 hover:bg-green-600 text-white rounded-lg shadow transition-colors flex items-center justify-center"
              >
                <RefreshCw size={20} className="mr-2" />
                Riprova
              </button>
              
              <button 
                onClick={() => window.location.href = '/'}
                className="w-full py-3 bg-stone-700 hover:bg-stone-600 text-amber-100 rounded-lg shadow transition-colors"
              >
                Torna alla home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;